import angular from 'angular';

angular
  .module('myConsultApp')
  .factory('OrganizationsService', ($resource, ENV, Session, Upload) => {
    const organizationService = {};

    const headers = { Authorization: `Bearer ${Session.accessToken}` };

    let organizationsList = null;

    organizationService.getOrganizations = () => {
      const service = $resource(`${ENV.apiEndpoint}/1.0/organizations/`, {}, { get: { headers } });

      return service.get().$promise.then((response) => {
        organizationsList = response.organizations;
        return response.organizations;
      });
    };

    organizationService.getOrganizationsList = () => organizationsList;

    organizationService.getPrimaryCareProvider = (petId) => {
      const service = $resource(
        `${ENV.apiEndpoint}/1.0/pets/:petId/providers/primary/`,
        { petId },
        { get: { headers } },
      );

      return service.get().$promise.then((response) => response.petProvider);
    };

    organizationService.getProviderSettings = (orgId) => {
      const service = $resource(
        `${ENV.apiEndpoint}/1.0/organizations/:orgId/settings/extended/`,
        { orgId },
        { get: { headers } },
      );

      return service.get().$promise.then((response) => response.organization);
    };

    organizationService.saveProviderSettings = (orgId, orgData) => {
      const service = $resource(
        `${ENV.apiEndpoint}/1.0/organizations/:orgId/settings/extended/`,
        { orgId },
        { save: { method: 'PUT', headers } },
      );

      return service.save(orgData).$promise;
    };

    organizationService.getOrganization = (orgId) => {
      const service = $resource(
        `${ENV.apiEndpoint}/1.0/organizations/:orgId`,
        { orgId },
        {},
        { get: { headers } },
      );

      return service.get().$promise.then((response) => response.organization);
    };

    organizationService.uploadLogo = (orgId, logo) => {
      return Upload.upload({
        url: `${ENV.apiEndpoint}/1.0/clinics/logos/${orgId}/`,
        data: {
          image: logo,
        },
        method: 'PUT',
        disableProgress: false,
      });
    };

    organizationService.deleteLogo = (orgId) => {
      return Upload.upload({
        url: `${ENV.apiEndpoint}/1.0/clinics/logos/${orgId}/`,
        method: 'DELETE',
        disableProgress: false,
      });
    };

    return organizationService;
  });
